import React from 'react';
import { HairRestorationPage } from './pages/HairRestorationPage';
export function App() {
  return <HairRestorationPage data-id="element-0" />;
}